<header id="app-header" class="header">
  <div id="app-header-content" class="header-content">
    <nibtravel-logo [config]="logoConfig"></nibtravel-logo>
  </div>
</header>
